import { render, staticRenderFns } from "./ChartOfAccounts.vue?vue&type=template&id=f37bf974&scoped=true"
import script from "./ChartOfAccounts.vue?vue&type=script&lang=js"
export * from "./ChartOfAccounts.vue?vue&type=script&lang=js"
import style0 from "./ChartOfAccounts.vue?vue&type=style&index=0&id=f37bf974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37bf974",
  null
  
)

export default component.exports